import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/layouts/AdminLayout";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const desc = (e) => [e.type_name, e.brand, e.model].filter(Boolean).join(" · ");

export default function EquipmentHistory() {
  const [serial, setSerial] = useState("");
  const [model, setModel] = useState("");
  const [data, setData] = useState(null);
  const search = async () => {
    try { const { data: d } = await api.get("/equipment-history", { params: { serial: serial || undefined, model: model || undefined } }); setData(d); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="equipment-history-page">
      <PageHeader eyebrow="Equipos" title="Historial de equipos" />
      <div className="mb-5 flex flex-wrap gap-2">
        <Input className="h-11 w-56" placeholder="Número de serie" value={serial} onChange={(e) => setSerial(e.target.value)} data-testid="eh-serial-input" />
        <Input className="h-11 w-56" placeholder="Modelo" value={model} onChange={(e) => setModel(e.target.value)} data-testid="eh-model-input" />
        <Button className="h-11" onClick={search} disabled={!serial.trim() && !model.trim()} data-testid="eh-search-button"><Search className="mr-1 h-4 w-4" />Buscar</Button>
      </div>
      {data && (
        <div className="space-y-6">
          <section className="space-y-2" data-testid="eh-replacements">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">Sustituciones ({data.replacements.length})</h2>
            {data.replacements.map((e) => (
              <div key={e.id} className="rounded-xl border border-border bg-card/40 px-4 py-3 text-sm" data-testid={`eh-rep-${e.id}`}>
                <div><span className="font-medium text-orange-400">Sustituido</span> {desc(e.old)}{e.old.serial ? ` · S/N ${e.old.serial}` : ""} → {e.new.model || "—"}{e.new.serial ? ` S/N ${e.new.serial}` : ""}</div>
                <div className="text-xs text-muted-foreground">{e.client_name} · {fmtDate(e.replaced_at)} · OS origen <Link className="text-primary" to={`/admin/os/${e.origin_wo_id}`}>{e.origin_folio}</Link> · BIS <Link className="text-primary" to={`/admin/os/${e.bis_wo_id}`}>{e.bis_folio}</Link> · Destino {e.destination_label}{e.custodian ? ` (${e.custodian}, ${fmtDate(e.custody_date)})` : ""} · Garantía nueva hasta {fmtDate(e.new_warranty_end)}</div>
              </div>
            ))}
          </section>
          {data.installed.length > 0 && (
            <section className="space-y-2" data-testid="eh-installed">
              <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">Instalaciones con ese modelo ({data.installed.length})</h2>
              {data.installed.map((e, i) => (
                <div key={i} className="rounded-xl border border-border bg-card/40 px-4 py-3 text-sm" data-testid={`eh-installed-${i}`}>
                  <span className={e.status === "Sustituido" ? "font-medium text-orange-400" : "font-medium text-emerald-400"}>{e.status}</span> {desc(e)} ×{e.quantity}
                  <div className="text-xs text-muted-foreground">{e.client_name} · <Link className="text-primary" to={`/admin/os/${e.wo_id}`}>{e.folio}</Link> · instalado {fmtDate(e.installed_at)} · garantía hasta {fmtDate(e.warranty_end)}</div>
                </div>
              ))}
            </section>
          )}
        </div>
      )}
    </div>
  );
}
